import { Directive, ElementRef, AfterViewInit, OnInit, Renderer2, HostBinding, ViewChild, HostListener } from '@angular/core';

import { CartPopupService } from '../cart-popup.shared.service';

@Directive({
    selector: '[directive-cart-popup]',
})
export class CartPopupDirective implements OnInit, AfterViewInit {
    private _elem: HTMLElement;
    private _offset: number = 0;
    private _resizeTimeoutTrigger: number = null;
    public mode: 'target' | 'popup' = 'target';

    @HostBinding('style.top.px') public top: string = null;
    @HostBinding('style.left.px') public left: string = null;
    @HostBinding('style.opacity') public opacity: string = null;

    @ViewChild('indicator', { static: true }) public indicator: ElementRef;
    @HostListener('window:resize') public onWindowResize(): void {
        if (this._resizeTimeoutTrigger) {
            clearTimeout(this._resizeTimeoutTrigger);
            this._resizeTimeoutTrigger = null;
        }

        setTimeout(() => {
            this._setElementsCoords();
        }, 200);
    }

    constructor(
        private _renderer2: Renderer2,
        private _elementRef: ElementRef,
        private _cartPopupService: CartPopupService,
    ) { }

    ngOnInit(): void {
        this._elem = this._elementRef.nativeElement;

        const tempMode = this._elem.getAttribute('directive-cart-popup');
        if (tempMode === 'popup') {
            this.mode = 'popup';
            if (!this._isMobile()) {
                this.opacity = '0';
            }
        } else if (tempMode === 'target' || '') {
            this.mode = 'target';
        } else {
            this.mode = null;
            return console.warn('Invalid mode provided id directive-cart-popup. Should be "popup" or "target". Is: ', tempMode, ' Element: ', this._elem);
        }
    }

    ngAfterViewInit(): void {
        this._setElementsCoords();
    }

    private _setElementsCoords(): void {
        if (!this.mode) return;

        if (this.mode === 'target') {
            /* Find cart button */
            this._cartPopupService.setTargetCoords(this._elem);
        }

        if (this.mode === 'popup') {
            /* Based on cart button, calculate popup position */
            this._calculatePopupPosition();
        }
    }

    private _isMobile(): boolean {
        return window.innerWidth < 768;
    }

    private _unsetPopupPositionStyles(): void {
        this.top = null;
        this.left = null;
        if (this.mode === 'popup') {
            if (!this._isMobile()) {
                this.opacity = '0';
            }
        }
        return;
    }

    private _calculatePopupPosition(): void {
        this._offset = this._cartPopupService.offset;

        setTimeout(() => {
            if (this._isMobile()) {
                return this._unsetPopupPositionStyles();
            }

            const target: ClientRect = this._cartPopupService.getTargetCoords();
            if (!target) {
                return this._unsetPopupPositionStyles();
            }

            // const stickToRight: boolean = (target.left + this._elem.clientWidth + this._offset) < window.innerWidth;
            // if (stickToRight) {
            this.left = `${(target.left + target.width + this._offset) - this._elem.clientWidth}`;
            // } else {
            //    this.left = `${target.left - this._offset}`;
            // }

            this.top = `${target.top + target.height + this._offset}`;
            if (this.mode === 'popup' && !this._isMobile()) {
                setTimeout(() => {
                    this.opacity = '1';
                }, 10);
            }
        }, 0);

    }
}
